import React from "react";
import {Params, UIMatch, useMatches} from "react-router";
import {BreadcrumbsWrapperCss} from "./BreadcrumbsWrapper.css";
import {Breadcrumbs} from "@elcimai/webankdesignsystem";

interface IMatches extends UIMatch<unknown,  { crumb?:()=>void,isLinkable?:()=>void }> {
    id: string;
    pathname: string;
    params: Params;
    data: unknown;
    handle: {
        crumb?:()=>void,
        isLinkable?:()=>void,
    };
}
const BreadcrumbsWrapper = () => {
    const matches = useMatches();
    const crumbs:IMatches[] = matches.filter((match) => Boolean((match.handle as { crumb?:()=>void,isLinkable?:()=>void })?.crumb)) as IMatches[]
    const links = crumbs.map((match) => { return {
        id: match.id,
        link: match.handle?.isLinkable?.()?match.pathname:undefined,
        label: match.handle?.crumb?.() || "",
    }
    });
    return <div className={BreadcrumbsWrapperCss}>
        <Breadcrumbs links={links} separator={"/"}></Breadcrumbs>
    </div>
}

export default BreadcrumbsWrapper